/**
 * Display helpers for match stats (see matchStats.js), shared by the standings tables,
 * player card and profile so every view formats the same player identically.
 */

/** Match win % as a whole-number string, e.g. "67%". Accepts a matchStats row or legacy wins/losses. */
export function formatWinPct(stats = {}) {
  const w = stats.w ?? stats.wins ?? 0;
  const l = stats.l ?? stats.losses ?? 0;
  const pct = stats.winPct !== undefined ? stats.winPct : (w + l > 0 ? w / (w + l) : 0);
  return `${Math.round(pct * 100)}%`;
}
